module.exports = __webpack_public_path__ + "static/nxrt-esports-91eb81c7f993d486adf7f0f12c2d48c5.jpg";